export default __webpack_public_path__ + "static/media/team_goals.54af3ab6.svg";